import { Component, Input } from '@angular/core';
import { IRptDtxDet } from '../../../shared/interfaces/rptDtx';
import { MatTableDataSource } from '@angular/material/table';

import { OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-rpt-dtx-detail',
  imports: [],
  templateUrl: './rpt-dtx-detail.component.html',
  styleUrl: '../rpt-dtx.component.css',
  standalone: false
})

export class RptDtxDetailComponent implements OnChanges {
  @Input() detail: IRptDtxDet[];
  @Input() engLang: boolean;

  dataSource: MatTableDataSource<IRptDtxDet> = new MatTableDataSource<IRptDtxDet>();
  displayedColumns: string[] = [
    'DetPS',
    'detPcodeCol',
    'detXpect1',
    'detXpect2',
    'detPvdo',
    'detQty'
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['detail'] && this.detail) {
      this.dataSource.data = this.detail.slice(); // Create a new array to avoid reference issues
    }
  }

  makeNum(value: number | string): number {
    return Number(value.toString().replace(/,/g, '')); // Convert string with commas to number
  }
}
